export default __webpack_public_path__ + "7ba9dafa8aaa872726b9739a0ab1d1fb.png";